var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footerShp",attrs:{"height":"auto"}},[_c('a',{staticClass:"mx-auto",attrs:{"href":"https://www.datadec.es","target":"_blank","rel":"noopener noreferrer"}},[_c('span',{staticClass:"footerInfo"},[_vm._v(" "+_vm._s(this.$t('poweredDatadec'))+" ")])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60594d77","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShpFooterApp.vue
// module id = null
// module chunks = 